import { ICreateUserGroupResponse } from 'multirpc-sdk';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TeamsSlice } from './types';

const initialState: TeamsSlice = {
  createTeamResponse: undefined,
  shouldContinueTeamCreationFlow: false,
};

export const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setNewTeamData: (
      state,
      action: PayloadAction<ICreateUserGroupResponse>,
    ) => {
      state.createTeamResponse = action.payload;
    },
    setShouldContinueTeamCreationFlow: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.shouldContinueTeamCreationFlow = action.payload;
    },
    resetTeamsSlice: () => initialState,
  },
});

export const {
  resetTeamsSlice,
  setNewTeamData,
  setShouldContinueTeamCreationFlow,
} = teamsSlice.actions;
